export default __webpack_public_path__ + "static/media/cooking_2020_OV_seemore_SD-ZP2000EU-K_07_201218.9f46ca6c.jpg";